const openSidebarButtons = document.querySelectorAll('.js-open-sidebar');
const overlay = document.getElementById('js-overlay');
const closeIcons = document.querySelectorAll('.js-close-sidebar');
const body = document.querySelector('body');

if (openSidebarButtons) {
    openSidebarButtons.forEach(function (button) {
        button.addEventListener('click', function (event) {
            event.preventDefault();
            const sidebarId = this.getAttribute('data-sidebar');
            const sidebar = document.querySelector(sidebarId);
            const sidebars = document.querySelectorAll('.sidebar');

            if(sidebars.length > 0) {
                sidebars.forEach(function (sidebar) {
                    sidebar.classList.remove('sidebar-is-open');
                });
            }

            if(sidebar) {
                sidebar.classList.add('sidebar-is-open');
                if (overlay) {
                    overlay.style.display = 'block';
                }
                body.classList.add('sidebar-no-scroll');
            }

        });
    });
}

if (closeIcons) {
    closeIcons.forEach(function(icon) {
        icon.addEventListener('click', function() {
          const sidebar = this.closest('.sidebar');
          if(sidebar) {
              sidebar.classList.remove('sidebar-is-open');
              if (overlay) {
                  overlay.style.display = 'none';
              }
              body.classList.remove('sidebar-no-scroll');
          }
        });
      });
}

if (overlay) {
    overlay.addEventListener('click', function () {
        const sidebars = document.querySelectorAll('.sidebar');

        if(sidebars.length > 0) {
            sidebars.forEach(function (sidebar) {
                sidebar.classList.remove('sidebar-is-open');
            });
        }

        this.style.display = 'none';
        body.classList.remove('sidebar-no-scroll');
    });
}



// WEBPACK FOOTER //
// ./scripts/components/sidebar.js